import useUnreadMessageCount from '@hooks/sendbird/useUnreadMessageCount';
import { openMessageWindow } from '@libraries/message';

export default function MessageMenuItem() {
  const unreadCount = useUnreadMessageCount();

  const onOpenMessageWindow = () => openMessageWindow();

  return (
    <button
      type="button"
      className="w-full py-[12px] px-[20px] rounded-[8px] text-lef
      content_primary font_label_regular_lg surface_primary hover:surface_tertiary
      text-ellipsis overflow-hidden whitespace-nowrap"
      onClick={onOpenMessageWindow}
    >
      <span className="gap-[4px] flex">
        메시지
        {unreadCount > 0 && (
          <span
            className="rounded-full px-[8px] h-[18px]
            items-center justify-center flex text-[10px]
            font-medium content_primary surface_accent_light_active "
          >
            {unreadCount}
          </span>
        )}
      </span>
    </button>
  );
}
